export const textStyles = {
  h1: {
    as: 'h1',
    fontSize: ['48px', '72px'],
    fontWeight: 'bold',
    lineHeight: '110%',
    letterSpacing: '-2%',
  },
}
